// @flow
import * as React from 'react';

import FlexibleDatesOption from './FlexibleDatesOption';
import FlexibleDatesProvider from './FlexibleDatesProvider';

import type {FlexibleDatesDesktopMobileProps} from './FlexibleDates';

import './FlexibleDatesDesktop.less';

export default function FlexibleDatesDesktop({
    title,
    loading,
    options,
    startDate,
    endDate,
    resultCount,
    ...props
}: FlexibleDatesDesktopMobileProps) {
    return (
        <div className="FlexibleDatesDesktop">
            <p className="FlexibleDatesDesktop__Title">{title}</p>
            <div className="FlexibleDatesDesktop__Container">
                <FlexibleDatesProvider
                    loading={loading}
                    options={options}
                    startDate={startDate}
                    endDate={endDate}
                    resultCount={resultCount}
                >
                    {(flexibleDateOptions, isLoading) => {
                        return flexibleDateOptions.map((newOptions) => (
                            <FlexibleDatesOption
                                {...props}
                                {...newOptions}
                                loading={loading || isLoading}
                            />
                        ));
                    }}
                </FlexibleDatesProvider>
            </div>
        </div>
    );
}
